/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrencyModel } from '../../models/currency-model';
import { CurrencyUpdateModel } from '../../models/currency-update-model';

export interface PutApiCurrencyV1Id$Plain$Params {

/**
 * The unique identifier of the currency to update.
 */
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The CurrencyUpdateModel containing updated currency data.
     */
    body?: CurrencyUpdateModel
}

export function putApiCurrencyV1Id$Plain(http: HttpClient, rootUrl: string, params: PutApiCurrencyV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CurrencyModel>>> {
  const rb = new RequestBuilder(rootUrl, putApiCurrencyV1Id$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CurrencyModel>>;
    })
  );
}

putApiCurrencyV1Id$Plain.PATH = '/private/v1/currencies/{id}';
